import React from "react";
import styled from "styled-components/macro";

function ToggleButton({ value, onChange }) {
  return (
    <ToggleButtonGroup>
      <LeftButton aria-pressed={value === "oldest_case"} onClick={() => onChange("oldest_case")}>
        Oldest
      </LeftButton>
      <RightButton aria-pressed={value === "newest_case"} onClick={() => onChange("newest_case")}>
        Newest
      </RightButton>
    </ToggleButtonGroup>
  );
}

export default ToggleButton;

const ToggleButtonGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  height: 2.5rem;
  color: var(--juno-color-text);
  min-width: fit-content;
`;

const Button = styled.button`
  /* #ebecf0 stays a literal: no palette token matches it. */
  background: #ebecf0;
  color: var(--juno-color-purple);
  border-color: #ebecf0;
  cursor: pointer;
  transition:
    background-color 100ms ease,
    border-color 100ms ease,
    color 100ms ease;

  font-weight: bold;
  font-size: 14px;
  border-style: solid; /* override outset */
  height: 100%;
  padding: 0 16px;

  &[aria-pressed="true"] {
    background: var(--juno-color-purple);
    color: var(--juno-color-white);
    border-color: var(--juno-color-purple);
    cursor: default;
  }

  /* Hover shifts the background and the border that matches it. The label
     stays at full strength: a filled segment must mean "selected". */
  &:not([aria-pressed="true"]):hover {
    background: var(--juno-color-pale-purple);
    border-color: var(--juno-color-pale-purple);
  }
`;

const LeftButton = styled(Button)`
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
`;

const RightButton = styled(Button)`
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
`;
